import styled from 'styled-components';
import { applySkeletonGradient } from '../mixins';

/**
 * Делает компонент скелетоном - у него заменяется фоновый цвет,
 * добавляется градиент и текст становится на 100% прозрачным.
 */
export var withSkeleton = function withSkeleton(Component) {
  return styled(Component).withConfig({
    componentId: "plasma__sc-9jbt81-0"
  })(["", ""], function (_ref) {
    var skeleton = _ref.skeleton;
    return skeleton && applySkeletonGradient({
      lighter: true
    });
  });
};